export interface IAppConfig {
    rowLimit: number;
    termsUrl: string;
    privacyUrl: string;
}

export const APP_CONFIG: IAppConfig = {
    rowLimit: 25,
    termsUrl: 'https://docs.fairville.be/buck-e-legal-documents/welkom/algemene-voorwaarden',
    privacyUrl: 'https://docs.fairville.be/buck-e-legal-documents/welkom/privacy-verklaring',
};
